import { render } from "./Ready.vue?vue&type=template&id=bc03a4e6"
import script from "./Ready.vue?vue&type=script&lang=js"
export * from "./Ready.vue?vue&type=script&lang=js"
script.render = render

export default script